/* eslint-disable @typescript-eslint/camelcase */
import React, { useState, SetStateAction, useContext } from 'react';
import edit from '../../../../../../assets/img/icons/edit.png';
import loader from '../../../../../../assets/img/icons/TizetiLoaderColored.gif';
import helpers from '../../../../../../utils/helpers';
import view from '../../../../../../assets/img/icons/view.png';
import ViewSheetDedicatedCustomer from './ViewSheetDedicatedCustomer';
// import { SheetDedicatedCustomerProps } from './types/SheetDedicatedCustomerProps';
import SheetDedicatedCustomerContext from './context/SheetDedicatedCustomerContext';

const SheetDedicatedCustomerTable = () => {
  const { loading: load, data } = useContext(SheetDedicatedCustomerContext);
  const [one, setOne] = useState({
    created_at: '',
    deleted_at: '',
    pptp_ip: '',
    id: '',
    public_ip: '',
    private_ip: '',
    tizeti_site_id: '',
  });
  const onClick = (params) => {
    setOne(params);
  };
  const tableData =
    data && data.length
      ? data.map((row, i) => (
          <tr className="text-nowrap" key={row.id}>
            <td>{i + 1}</td>
            <td>{row.customer}</td>
            <td>{row.ap}</td>
            <td>{row.station}</td>
            <td>{row.ssid}</td>

            <td>{row.password}</td>
            <td>{row.frequency}</td>
            <td>{row.device}</td>
            <td>{row.router}</td>
            <td>{row.no_of_access_point}</td>
            <td>{row.access_point_type}</td>
            <td>{row.local_network}</td>
            <td>{row.bandwidth}</td>
            <td>{helpers.formatDateAndTime(row.created_at)}</td>
            <td>
              <div className="text-center">
                <button
                  type="submit"
                  className="mr-2"
                  data-toggle="modal"
                  data-placement="right"
                  data-target="#view_access-point"
                  onClick={() => onClick(row)}
                >
                  <span className="view">
                    <img src={view} data-toggle="tooltip" alt="" data-placement="top" title="View" />
                  </span>
                </button>
                <button
                  type="submit"
                  className="mr-2"
                  data-toggle="modal"
                  data-placement="right"
                  data-target="#update_item"
                  // onClick={() => getItem(list)}
                >
                  <span className="view">
                    <img src={edit} data-toggle="tooltip" alt="" data-placement="top" title="Edit" />
                  </span>
                </button>
              </div>
              <ViewSheetDedicatedCustomer view={one} />
              {/* <EditRetrievalItem OneItem={one} /> */}
            </td>
          </tr>
        ))
      : 'no facebook site';
  return (
    <div className="card x-panel mt-2 px-0">
      <div className="table-responsive content col-12 px-1">
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Customer</th>
              <th className="text-nowrap">Public IP</th>
              <th>Ap</th>
              <th>Station</th>
              <th>Password</th>
              <th>Device</th>
              <th>Router</th>
              <th>No Of Access Point</th>
              <th>Access Point Type</th>
              <th>Local Network</th>
              <th>Bandwidth</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {load ? (
              <tr>
                {/* <td colSpan="9" className="text-center"> */}
                <img src={loader} alt="loading gif" />
                {/* </td> */}
              </tr>
            ) : (
              tableData
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SheetDedicatedCustomerTable;
